/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingResponse } from '../../models/setting-response';

export interface GetAllOrganizationSiteSettings$Params {
}

export function getAllOrganizationSiteSettings(http: HttpClient, rootUrl: string, params?: GetAllOrganizationSiteSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllOrganizationSiteSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SettingResponse>>;
    })
  );
}

getAllOrganizationSiteSettings.PATH = '/organization-sites/settings';
